/** The Arqam mark (house with rising bars), from docs/assets/mark.svg. Decorative. */
export function Mark({ size = 30 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 400 400" aria-hidden="true" focusable="false">
      <g
        fill="none"
        stroke="currentColor"
        strokeWidth={26}
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <polyline points="92,330 92,176 200,76 308,176 308,330" />
        <polyline points="92,330 160,330" />
        <polyline points="240,330 308,330" />
      </g>
      <rect x="128" y="262" width="40" height="38" rx="6" fill="#d97706" />
      <rect x="180" y="222" width="40" height="78" rx="6" fill="#f5a524" />
      <rect x="232" y="182" width="40" height="118" rx="6" fill="#fbbf24" />
      <circle cx="252" cy="156" r="12" fill="#f5a524" />
    </svg>
  )
}
